import React from 'react'
import styles from './browseCat.module.css'
import { useNavigate } from 'react-router-dom';

const BrowseCat = ({topCategories}) => {
   const navigate = useNavigate()


  

    return (
        <section className={styles.browseContainer}>
            <div className={styles.browseContent}>
            <div className={styles.browseRow1}>
                <div>
                    <span className={styles.eyebrow}>Component catalogue</span>
                    <h2>Browse Categories</h2>
                    <p className={styles.browseIntro}>Choose a category to explore products.</p>
                </div>
                <button type="button" className={styles.seeMoreBtn} onClick={() => navigate('/categories')}>
                    <span className={styles.seeMoreLabel}>See all categories</span>
                    <span className={styles.seeMoreArrow} aria-hidden="true">→</span>
                </button>
            </div>
            <div className={styles.browseRow2}>
                <div className={styles.regRow}>

                    {topCategories?.map((category, index) => {
                        return (
                            <button
                                key={category?._id || category?.name}
                                type="button"
                                className={styles.regCol}
                                onClick={() => navigate(`/subcategories/${category?._id}`)}
                                style={{ '--card-delay': `${Math.min(index * 45, 450)}ms` }}
                            >
                                <span className={styles.iconShell}>
                                    <img src={category?.thumbnail?.photo[0]} alt="" className={styles.categoryImage} />
                                </span>
                                <span className={styles.categoryName}>{category?.name}</span>
                                <span className={styles.exploreLabel}>Explore <span aria-hidden="true">→</span></span>
                            </button>
                        )

                    })

                    }


                </div>

            </div>
            </div>
        </section>
    )
}

export default BrowseCat
